var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoBmr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.859,
    height: 45.618,
    viewBox: "0 0 33.859 45.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13732.581 10779.775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.831,19.3q-.292.592-.573,1.15c-1.6,3.2-2.866,5.72-2.866,9.343a14.93,14.93,0,1,0,29.86,0c0-6.994-3.309-10.822-6.51-14.525-2.795-3.233-5.434-6.287-5.434-10.955a10.416,10.416,0,0,1,.059-1.109A24.908,24.908,0,0,0,16.8,6.678,28.069,28.069,0,0,0,13.257,25.9l.393,2.609-2.439-1.006a11.074,11.074,0,0,1-5.5-5.813,16.326,16.326,0,0,1-.884-2.39Zm0,0",
    transform: "translate(-13731.973 -10780.982)",
    fill: "none",
    stroke: "#394f65",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBmr);
export default __webpack_public_path__ + "static/media/ICO-BMR.c8ddf29a7350c1620ab8c50281e76182.svg";
export { ForwardRef as ReactComponent };